import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Image,
  Button,
  Container,
} from "@themesberg/react-bootstrap";
import ErrorImage from "../assets/img/illustrations/500.svg";

const ErrorFallback = ({ resetErrorBoundary }) => {
  return (
    <main>
      <section className="vh-100 d-flex align-items-center justify-content-center">
        <Container>
          <Row className="align-items-center">
            <Col
              xs={12}
              lg={5}
              className="order-2 order-lg-1 text-center text-lg-left"
            >
              <h1 className="text-primary mt-5">
                Something has gone <span className="fw-bolder">wrong</span>
              </h1>
              <p className="lead my-4">
                An unexpected error occurred. Try reloading this page — if the
                problem continues, please contact support.
              </p>
              <Button
                variant="primary"
                className="animate-hover"
                onClick={resetErrorBoundary}
              >
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  className="animate-left-3 me-3 ms-2"
                />
                Reload page
              </Button>
            </Col>
            <Col
              xs={12}
              lg={7}
              className="order-1 order-lg-2 text-center d-flex align-items-center justify-content-center"
            >
              <Image src={ErrorImage} className="img-fluid w-75" />
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

const handleError = (error, info) => {
  // Central place to forward render errors to a monitoring service (e.g. Sentry).
  console.error("Uncaught render error:", error, info?.componentStack);
};

const AppErrorBoundary = ({ children }) => {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={handleError}
      onReset={() => {
        window.location.reload();
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

export default AppErrorBoundary;
